import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Loader from "./component/Loader/Loader";
import Pricing from "./pages/Pricing/Pricing";
import ManageSubscription from "./pages/Manage Subscription/ManageSubscription";
import Support from "./pages/Support/Support";
import Login from "./pages/Login/Login";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutWrapper from "./pages/Checkout/CheckoutWrapper";
import Download from "./pages/Download/Download";
import Home from "./pages/Home/Home";
import axios from "axios";
import PublicRoute from "./protected/PublicRoute";
import ProtectedRoute from "./protected/ProtectedRoute";
import Demo from "./pages/Demo/Demo";
import WebApp from "./pages/WebApp/WebApp";
import PathTracker from "./protected/PathTracker";
import PWAStartGate from "./protected/PWAStartGate";
import { UsageProvider } from "./context/UsageContext";
import { NotificationsProvider } from "./context/NotificationsContext";
import { DownloadProvider } from "./pages/DownloadWindow/DownloadContext";
import ScrollToTop from "./component/ScrollTop";
import Seo from "./component/Seo/Seo";
import HowItWorks from "./pages/Video/HowitWorks";
import PrivacyPolicy from "./pages/Policies/PrivacyPolicy";
import TermsOfService from "./pages/Policies/TermsOfService";
import DataProcessingTerms from "./pages/Policies/DataProcessingTerms";
import Blog from "./pages/Blog/Blog";
import BlogPost from "./pages/Blog/BlogPost";
import HelpCategory from "./pages/Support/HelpCategory";
import HelpArticle from "./pages/Support/HelpArticle";
import { trackEvent } from "./lib/mixpanel";
import Usage from "./pages/Usage/Usage";
import SignupSuccess from "./pages/SignupSuccess/SignupSuccess";
import SignInSuccessful from "./pages/SignInSuccessful/SignInSuccessful";
import PaymentSuccess from "./pages/PaymentSuccess/PaymentSuccess";
import DownloadForWindow from "./pages/DownloadWindow/DownloadForWindow";
import DownloadForMac from "./pages/DownloadMac/DownloadForMac";
import LoginNew from "./pages/Login/LoginNew";
import VoiceTypingForGoogleDocs from "./pages/VoiceTypingForGoogleDocs/VoiceTypingForGoogleDocs";
import HowVoiceTypingWorks from "./pages/HowVoicetypingWorks/HowVoiceTypingWorks";
import VoicePromptingAI from "./pages/DictatingAiPrompts/VoicePromptingAI";
import Blogs from "./pages/Blogs/Blogs";
import NotFound from "./pages/NotFound/NotFound";

const stripePromise = loadStripe(
  "pk_live_51RD0PIHVT97b1nEmemlvpOnBp7tl6oZqJGkzajpMWIqs7F2tvp7eSiRXArBaChnXCqOJKwaHSGaHopIctPsmOnGz00mVwptY14"
);

// const stripePromise = loadStripe(
//   "pk_test_51RD0PIHVT97b1nEmiwArEddRwUTX2K85Y067GU59FAGBaJae9dYxJKY3suSJn1NltmsvP8vKCTxMaNVuUGqcthA000pfzSLyYu"
// );

axios.defaults.withCredentials = true;
function App() {
  // useEffect(() => {
  //   const disableRightClick = (e) => e.preventDefault();

  //   const handleKeyDown = (e) => {
  //     if (
  //       e.key === "F12" ||
  //       (e.ctrlKey && e.shiftKey && e.key === "I") ||
  //       (e.ctrlKey && e.shiftKey && e.key === "C") ||
  //       (e.ctrlKey && e.shiftKey && e.key === "J")
  //     ) {
  //       e.preventDefault();
  //     }
  //   };

  //   const detectContextMenu = (e) => {
  //     e.preventDefault();
  //     console.log("Right-click is disabled");
  //   };

  //   document.addEventListener("contextmenu", detectContextMenu);
  //   document.addEventListener("keydown", handleKeyDown);

  //   const detectDevTools = () => {
  //     const devToolsOpen = /./;
  //     devToolsOpen.toString = function () {
  //       console.log("Developer tools are disabled");
  //     };
  //     console.log(devToolsOpen);
  //   };

  //   detectDevTools();
  //   return () => {
  //     document.removeEventListener("contextmenu", detectContextMenu);
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    trackEvent("app_opened");
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Seo />

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        progressClassName="toastProgress"
        className={"custom-toast-container"}
        limit={3}
      />
      <PathTracker />
      <PWAStartGate />
      <UsageProvider>
        <NotificationsProvider>
          <DownloadProvider>
            <Routes>
              <Route
                path="/"
                element={
                  isLoading ? (
                    <div className="w-full">
                      <Loader />
                    </div>
                  ) : (
                    <div className=" tracking-[-0.015em] ">
                      <Home />
                    </div>
                  )
                }
              />

              <Route path="/demo" element={<Demo />} />
              <Route
                path="/app"
                element={
                  <ProtectedRoute>
                    <WebApp />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/pricing"
                element={
                  <div className=" tracking-[-0.015em]">
                    <Pricing />
                  </div>
                }
              />
              <Route
                path="/help"
                element={
                  <div className=" tracking-[-0.015em]">
                    <Support />
                  </div>
                }
              />
              {/* <Route
              path="/login"
              element={
                <PublicRoute>
                  <LoginNew />
                </PublicRoute>
              }
            /> */}
              <Route
                path="/download"
                element={
                  <div className=" tracking-[-0.015em] ">
                    <Download />
                  </div>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <ManageSubscription />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/usage"
                element={
                  <ProtectedRoute>
                    <Usage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/checkout/:planId/:clientSecret"
                element={
                  <div className="max-w-screen-2xl mx-auto  ">
                    <CheckoutWrapper stripePromise={stripePromise} />
                  </div>
                }
              />

              <Route
                path="/how-it-works"
                element={
                  <div className=" tracking-[-0.015em]">
                    <HowItWorks />
                  </div>
                }
              />

              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/data-processing-terms" element={<DataProcessingTerms />} />

              <Route
                path="/help/topic/:categorySlug"
                element={<HelpCategory />}
              />
              <Route
                path="/help/topic/:categorySlug/:articleSlug"
                element={<HelpArticle />}
              />
              <Route path="/help/all" element={<Blog />} />
              <Route path="/help/:slug" element={<BlogPost />} />

              <Route path="/signup-successful" element={<SignupSuccess />} />

              {/* Desktop SSO handoff: deep-links tokens back into the native app */}
              <Route path="/sign-in-successful" element={<SignInSuccessful />} />

              <Route
                path="/payment-successful"
                element={
                  <ProtectedRoute>
                    <PaymentSuccess />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/windows"
                element={
                  <div className=" tracking-[-0.015em]">
                    <DownloadForWindow />
                  </div>
                }
              />

              <Route
                path="/mac"
                element={
                  <div className=" tracking-[-0.015em]">
                    <DownloadForMac />
                  </div>
                }
              />

              <Route
                path="/login"
                element={
                  <PublicRoute>
                    <LoginNew />
                  </PublicRoute>
                }
              />

              <Route
                path="/voice-typing-for-google-docs"
                element={<VoiceTypingForGoogleDocs />}
              />

              <Route
                path="/how-ai-voice-typing-works"
                element={<HowVoiceTypingWorks />}
              />

              <Route
                path="/voice-prompting-ai"
                element={<VoicePromptingAI />}
              />

              <Route path="/blogs" element={<Blogs />} />

              {/* Anything that matches no route above */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </DownloadProvider>
        </NotificationsProvider>
      </UsageProvider>
    </BrowserRouter>
  );
}

export default App;
